import { render, staticRenderFns } from "./CampaignsRanking.vue?vue&type=template&id=470ca48b&scoped=true&lang=pug&"
import script from "./CampaignsRanking.vue?vue&type=script&lang=js&"
export * from "./CampaignsRanking.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsRanking.vue?vue&type=style&index=0&id=470ca48b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470ca48b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VImg,VRow})
